// magicLinkAuth.ts
import { sendSignInLinkToEmail } from "firebase/auth";
import { firebaseAuth } from "../../../../api/firebase/firestoreService";
import { makeMagicLinkSignUpCall } from "../../../../api/postCall/magicLinkSignUp";
import { generateValidUrl } from "./getValidUrl";

const actionCodeSettings = {
  url: generateValidUrl(),
  handleCodeInApp: true,
};

export const sendMagicLinkViaEmail = async (email: string) => {
  try {
    if (window.location.href.includes("localhost")) {
      try {
        await sendSignInLinkToEmail(firebaseAuth, email, actionCodeSettings);
        window.localStorage.setItem("emailForSignIn", email);
        return true;
      } catch (error) {
        console.error("Error sending magic link:", error);
        return false;
      }
    } else {
      const response = await makeMagicLinkSignUpCall({
        email,
        env: "production",
        action_code_url: actionCodeSettings.url,
      });
      window.localStorage.setItem("emailForSignIn", email);
      return response.success;
    }
  } catch (error) {
    console.error("Error sending magic link:", error);
    return false;
  }
};
